import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const SpacSchema = () =>
  yup.object({
    iD_Spac: yup
      .string()
      .max(5)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('SPAC')),
    name: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(255)
      .label(i18n2._('Nombre')),
    status: yup.number().label(i18n2._('Estado')),
    gxp: yup
      .number()
      .typeError(i18n2._('Ingrese un número correcto'))
      .nullable(true)
      .label(i18n2._('GXP')),
    building: yup
      .number()
      .typeError(i18n2._('Ingrese un número correcto'))
      .label(i18n2._('Planta')),
    bpOwner: yup.string().label(i18n2._('BP Propietario')),
    observation: yup.string().label(i18n2._('Observacion')),
    catSw: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Categoria de software')),
    catHw: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Categoria de hardware')),
    respUser: yup.string().max(100).label(i18n2._('Colaborador responsable')),
    sysOwner: yup.string().max(50).label(i18n2._('Dueño del sistema')),
    qaUnit: yup.string().max(50).label(i18n2._('Aseg.Calidad')),
    smExpert: yup.string().max(50).label(i18n2._('Experto Materia')),
    dateStIni: yup.date().nullable(true).label(i18n2._('Fecha inicial')),
    dateStFin: yup.date().nullable(true).label(i18n2._('Fecha fin')),
    dateRealIni: yup
      .date()
      .nullable(true)
      .label(i18n2._('Fecha real de inicio')),
    dateRealFin: yup.date().nullable(true).label(i18n2._('Fecha real de Fin')),
    dateReval: yup.date().nullable(true).label(i18n2._('Fecha Reval')),
    sysSupplier: yup.string().max(50).label(i18n2._('Proveedor de sistemas')),
    itService: yup.string().label(i18n2._('Servicio de IT')),
    hse: yup.bool().nullable(true).label(i18n2._('HSE')),
    active: yup
      .boolean()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Activo')),
    owner: yup.boolean().label(i18n2._('Propietario')),
    admIng: yup.bool().nullable(true).label(i18n2._('Administrador')),
    formXls: yup.bool().nullable(true).label(i18n2._('Fomulario XMLS')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
